<ng-container *transloco="let t">
  <beyond-online-drawer
    [open]="open()"
    (openedChanged)="open.set($event)"
    [size]="'l'"
  >
    <div class="drawer__container">
      <section class="drawer__header">
        <h3 class="drawer__title">{{ t("side-navigation.title") }}</h3>
        <beyond-online-icon-close-20
          class="drawer__icon"
          (click)="closeDrawer()"
        />
      </section>

      <section class="cta__container">
        @if (isLoading()) {
          @for (i of [1, 2, 3, 4]; track i) {
            <beyond-online-skeleton-container
              [width]="'100%'"
              [height]="'48px'"
              title="Consultation Placeholder"
            >
              <beyond-online-rectangle-skeleton
                #shape
                [width]="'100%'"
                [height]="'48px'"
                radius="s"
                [x]="0"
                [y]="0"
              />
            </beyond-online-skeleton-container>
          }
        } @else {
          @for (
            consultation of consultationResponse()?.data?.consultations;
            track consultation.consultation_id
          ) {
            <button
              class="consultation__button"
              beyond-online-button
              [routerLink]="
                `${CONSULTATION_ROUTE}/${consultation.consultation_id}`
              "
              (click)="closeDrawer()"
              variant="secondary"
              size="l"
              [label]="
                (consultation.created_at + 'Z' | date: 'yyyy-MM-dd HH:mm') ?? ''
              "
            ></button>
          }
          @if (!consultationResponse()?.data?.consultations?.length) {
            <p>{{ t("side-navigation.no-consultations") }}</p>
          }
        }
      </section>

      <a
        class="admin__button"
        [href]="'https://www.zeiss.com/data-protection/en/contact.html'"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div class="admin__icon-container">
          <beyond-online-icon-open-in-new-20 class="admin__icon" />
          <span class="admin__button-text">
            {{ t("side-navigation.data-privacy") }}
          </span>
        </div>
      </a>

      <button
        *hasPermission="isAdmin"
        class="admin__button"
        [routerLink]="ADMIN_ROUTE"
        (click)="closeDrawer()"
      >
        <div class="admin__icon-container">
          <beyond-online-icon-settings-20 class="admin__icon" />
          <span class="admin__button-text"
            >{{ t("admin-area.side-navigation-title") }}
          </span>
        </div>

        <beyond-online-icon-chevron-next-20 class="admin__icon" />
      </button>

      <footer class="drawer__footer">
        <div class="avatar__container">
          <beyond-online-avatar [fullName]="userFullName()" />
          <div class="user__info">
            <h4>{{ userFullName() }}</h4>
            <h5>{{ user().eMail }}</h5>
          </div>
        </div>
        <button
          beyond-online-button
          variant="primary"
          size="l"
          [label]="t('cta.button.logout')"
          (click)="logout()"
        ></button>
      </footer>
    </div>
  </beyond-online-drawer>
</ng-container>
